/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the core/testing package.
 */

export * from './async';
export * from './component_fixture';
export * from './fake_async';
export * from './test_bed';
export * from './testing';
export * from './metadata_override';
export * from './private_export_testing';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
